import type { StatusPillProps } from "./types"

const PILL_CONFIG: Record<
  import("./types").RoomStatus,
  { cls: string; label: string }
> = {
  live:    { cls: "bg-green-100 text-green-700",   label: "● Live"     },
  flagged: { cls: "bg-red-100 text-red-700",        label: "⚑ Flagged"  },
  paused:  { cls: "bg-amber-100 text-amber-800",    label: "⏸ Paused"   },
  rec:     { cls: "bg-violet-100 text-violet-700",  label: "◉ Rec only" },
  offline: { cls: "bg-gray-100 text-gray-500",      label: "● Offline"  },
};

export function StatusPill({ st }: Readonly<StatusPillProps>) {
  const { cls, label } = PILL_CONFIG[st] ?? PILL_CONFIG.offline;

  return (
    <span
      className={`inline-flex items-center gap-0.5 text-[10px] font-medium px-1.5 py-0.5 rounded-full shrink-0 ${cls}`}
    >
      {label}
    </span>
  );
}